import React, { useContext, useEffect, useReducer, useState } from "react";

import { Link as RouterLink, useHistory } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";

import ListItemIcon from "@material-ui/core/ListItemIcon";

import ListItemText from "@material-ui/core/ListItemText";

import Divider from "@material-ui/core/Divider";

import { Badge, Collapse, List } from "@material-ui/core";

import EventIcon from "@material-ui/icons/Event";

import EventAvailableIcon from "@material-ui/icons/EventAvailable";

import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import ListIcon from "@material-ui/icons/ListAlt";

import BusinessIcon from "@material-ui/icons/Business";

import { CalendarToday } from "@material-ui/icons";

import MailOutlineIcon from "@material-ui/icons/MailOutline";

import SendIcon from "@material-ui/icons/Send";

import ScheduleIcon from "@material-ui/icons/Schedule";

import LiveHelpIcon from "@material-ui/icons/LiveHelp";

import Typography from "@material-ui/core/Typography";

import { i18n } from "../translate/i18n";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";

import { AuthContext } from "../context/Auth/AuthContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";

import api from "../services/api";

import toastError from "../errors/toastError";

import usePlans from "../hooks/usePlans";

import useVersion from "../hooks/useVersion";

import { ShapeLine } from "@mui/icons-material";

import RotateRight from "@material-ui/icons/RotateRight";

import { useLicenseChecker } from "../license/validateLicense";

import moment from "moment";

import {

  PieChart,

  MessageCircle,

  KanbanSquare,

  MessagesSquare,

  Bookmark,

  HelpCircle,

  ListChecks,

  Users,

  CalendarPlus,

  Zap,

  TrendingUp,

  Settings2,

  Contact,

  ListTodo,

  BookOpen,

  MonitorCheck,

  Workflow,

  UserPlus,

  PlugZap,

  Landmark,

  Settings,

  ClipboardCheck,

  MessageSquare,

  Star,

  Home,

  Chat,

  Send,

  Mail,

  Calendar,

  Tag,

  Layers,

  LogOut,

} from "lucide-react";

import { makeStyles } from "@material-ui/core/styles";

import { SocketContext } from "../context/Socket/SocketContext";

import {
  MdDashboard,
  MdChat,
  MdSend,
  MdCalendarToday,
  MdAssignment,
  MdPeople,
  MdLabel,
  MdHelpOutline,
  MdViewKanban,
  MdLabelOutline,
  MdPlayCircleOutline,
  MdEmail,
  MdEventAvailable,
  MdSettings,
  MdBusiness,
  MdStar,
  MdFeedback,
  MdQueue,
  MdBuild,
  MdAccountBalance,
  MdLogout,
  MdCall
} from "react-icons/md";



const useStyles = makeStyles((theme) => ({

  ListSubheader: {

    height: 22,

    marginTop: "-10px",

    marginBottom: "10px",

  },

  listItem: {

    borderRadius: 8,

    margin: "2px 4px",

    minHeight: 36,

    padding: "2px 8px",

    transition: "all 0.3s ease",

    fontSize: "0.92rem",

    "&:hover": {

      backgroundColor: theme.palette.primary.main,

      color: "#fff",

      transform: "translateX(3px)",

      "& .MuiListItemIcon-root": {

        color: "#fff !important"

      }

    },

  },

  categoryTitle: {

    paddingLeft: 16,

    paddingTop: 8,

    marginBottom: 4,

    color: theme.palette.primary.main,

    fontWeight: 600,

    fontSize: "0.78rem",

    textTransform: "uppercase",

    letterSpacing: "0.1em"

  },

  iconColor: {

    color: theme.palette.text.secondary,

    transition: "color 0.3s ease",

    minWidth: 32,

    fontSize: 18,

  },

  disabledItem: {

    opacity: 0.6,

    pointerEvents: "none",

  },

  logoutButton: {

    borderRadius: 8,

    margin: "4px",

    backgroundColor: theme.palette.error.main,

    color: "#fff",

    transition: "all 0.3s ease",

    fontSize: "0.92rem",

    minHeight: 36,

    "&:hover": {

      backgroundColor: theme.palette.error.dark,

      transform: "translateX(3px)",

    },

  },

}));



function ListItemLink(props) {

  const { icon, primary, to, className, disabled, style, onClick } = props;



  const renderLink = React.useMemo(

    () =>

      React.forwardRef((itemProps, ref) => (

        <RouterLink to={to} ref={ref} {...itemProps} />

      )),

    [to]

  );



  return (

    <li>

      <ListItem

        dense

        button

        component={renderLink}

        className={`${className} ${disabled ? 'opacity-50 pointer-events-none' : ''}`}

        style={style}

        onClick={onClick}

      >

        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}

        <ListItemText primary={primary} />

      </ListItem>

    </li>

  );

}



const reducer = (state, action) => {

  if (action.type === "LOAD_CHATS") {

    const chats = action.payload;

    const newChats = [];



    if (isArray(chats)) {

      chats.forEach((chat) => {

        const chatIndex = state.findIndex((u) => u.id === chat.id);

        if (chatIndex !== -1) {

          state[chatIndex] = chat;

        } else {

          newChats.push(chat);

        }

      });

    }



    return [...state, ...newChats];

  }



  if (action.type === "UPDATE_CHATS") {

    const chat = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chat.id);



    if (chatIndex !== -1) {

      state[chatIndex] = chat;

      return [...state];

    } else {

      return [chat, ...state];

    }

  }



  if (action.type === "DELETE_CHAT") {

    const chatId = action.payload;



    const chatIndex = state.findIndex((u) => u.id === chatId);

    if (chatIndex !== -1) {

      state.splice(chatIndex, 1);

    }

    return [...state];

  }



  if (action.type === "RESET") {

    return [];

  }



  if (action.type === "CHANGE_CHAT") {

    const changedChats = state.map((chat) => {

      if (chat.id === action.payload.chat.id) {

        return action.payload.chat;

      }

      return chat;

    });

    return changedChats;

  }

};



const MainListItems = (props, { collapsed }) => {

  const classes = useStyles();

  const { drawerClose } = props;

  const { whatsApps } = useContext(WhatsAppsContext);

  const { user, handleLogout } = useContext(AuthContext);

  const socketManager = useContext(SocketContext);

  const [connectionWarning, setConnectionWarning] = useState(false);

  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);

  const [openKanbanSubmenu, setOpenKanbanSubmenu] = useState(false);

  const [openEmailSubmenu, setOpenEmailSubmenu] = useState(false);

  const [openEvaluationSubmenu, setOpenEvaluationSubmenu] = useState(false);

  const [showCampaigns, setShowCampaigns] = useState(false);

  const [showSchedules, setShowSchedules] = useState(false);

  const [showInternalChat, setShowInternalChat] = useState(false);

  const [showExternalApi, setShowExternalApi] = useState(false);

  const [useShowFlowBuilder, setUseShowFlowBuilder] = useState(false);

  const { plano } = useLicenseChecker();

  const history = useHistory();

  const [invisible, setInvisible] = useState(true);

  const [pageNumber, setPageNumber] = useState(1);

  const [searchParam] = useState("");

  const [chats, dispatch] = useReducer(reducer, []);

  const [version, setVersion] = useState(false);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();



  const isSubscriptionExpired = () => {

    if (!user?.company?.dueDate) return false;

    if (user.company.id === 1) return false;

    const dueDate = moment(user.company.dueDate);

    const today = moment();

    return !dueDate.isAfter(today);

  };



  const handleClickLogout = () => {

    handleLogout();

  };



  useEffect(() => {

    async function fetchVersion() {

      const _version = await getVersion();

      setVersion(_version.version);

    }

    fetchVersion();

  }, []);



  useEffect(() => {

    dispatch({ type: "RESET" });

    setPageNumber(1);

  }, [searchParam]);



  useEffect(() => {

    async function fetchData() {

      const planConfigs = await getPlanCompany(undefined, user.companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);

      setShowSchedules(planConfigs.plan.useSchedules);

      setShowInternalChat(planConfigs.plan.useInternalChat);

      setShowExternalApi(planConfigs.plan.useExternalApi);

      setUseShowFlowBuilder(planConfigs.plan.useShowFlowBuilder);

    }

    fetchData();

  }, [user]);



  useEffect(() => {

    const delayDebounceFn = setTimeout(() => {

      fetchChats();

    }, 500);

    return () => clearTimeout(delayDebounceFn);

  }, [searchParam, pageNumber]);



  useEffect(() => {

    const socket = socketManager.getSocket(user.companyId);

    const onCompanyChat = (data) => {

      if (data.action === "new-message") {

        dispatch({ type: "CHANGE_CHAT", payload: data });

      }

      if (data.action === "update") {

        dispatch({ type: "CHANGE_CHAT", payload: data });

      }

    };

    socket.on(`company-${user.companyId}-chat`, onCompanyChat);



    return () => {

      socket.off(`company-${user.companyId}-chat`, onCompanyChat);

    };

  }, [socketManager, user]);



  useEffect(() => {

    let unreadsCount = 0;

    if (chats.length > 0) {

      for (let chat of chats) {

        for (let chatUser of chat.users) {

          if (chatUser.userId === user.id) {

            unreadsCount += chatUser.unreads;

          }

        }

      }

    }

    if (unreadsCount > 0) {

      setInvisible(false);

    } else {

      setInvisible(true);

    }

  }, [chats, user.id]);



  useEffect(() => {

    const delayDebounceFn = setTimeout(() => {

      if (whatsApps.length > 0) {

        const offlineWhats = whatsApps.filter((whats) => {

          return (

            whats.status === "qrcode" ||

            whats.status === "PAIRING" ||

            whats.status === "DISCONNECTED" ||

            whats.status === "TIMEOUT" ||

            whats.status === "OPENING"

          );

        });

        if (offlineWhats.length > 0) {

          setConnectionWarning(true);

        } else {

          setConnectionWarning(false);

        }

      }

    }, 2000);

    return () => clearTimeout(delayDebounceFn);

  }, [whatsApps]);



  const fetchChats = async () => {

    try {

      const { data } = await api.get("/chats/", {

        params: { searchParam, pageNumber },

      });

      dispatch({ type: "LOAD_CHATS", payload: data.records });

    } catch (err) {

      toastError(err);

    }

  };



  const subscriptionExpired = isSubscriptionExpired();



  const menuCategories = {

    main: [

      {

        path: "/dashboard",

        name: "Dashboard",

        icon: <MdDashboard size={18} />,

        condition: (user.super || user.profile === 'admin')

      },

      {

        path: "/tickets",

        name: "Atendimentos",

        icon: <MdChat size={18} />

      },

      {

        path: "/quick-messages",

        name: "Respuestas Rápidas",

        icon: <MdSend size={18} />

      },

      {

        path: "/schedules",

        name: "Programaciones",

        icon: <MdCalendarToday size={18} />,

        condition: showSchedules

      },

      {

        path: "/todolist",

        name: "Tareas",

        icon: <MdAssignment size={18} />

      },

      {

        path: "/contacts",

        name: "Contactos",

        icon: <MdPeople size={18} />

      },

      {

        path: "/tags",

        name: "Etiquetas",

        icon: <MdLabel size={18} />

      },

      // {

      //   path: "/chats",

      //   name: i18n.t("mainDrawer.listItems.chats"),

      //   icon: <MessagesSquare size={22} strokeWidth={1.5} />,

      //   condition: showInternalChat && (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      // },

      {
        path: "/helps",
        name: "Ayuda",
        icon: <MdHelpOutline size={18} />
      }
    ],
    whatsappStatus: [
      {
        path: "/whatsapp-status",
        name: "Crear Estados WhatsApp",
        icon: <MdStar size={18} />
      },
      {
        path: "/whatsapp-status-list",
        name: "Estados Publicados",
        icon: <MdViewKanban size={18} />
      }
    ],
    calls: [
      {
        path: "/calls",
        name: "Llamadas",
        icon: <MdCall size={18} />
      }
    ],

    email: [

      {

        path: "/Email",

        name: "Enviar Email",

        icon: <MdEmail size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/EmailLis",

        name: "Emails Enviados",

        icon: <MdEmail size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/EmailScheduler",

        name: "Agendar Email",

        icon: <MdEventAvailable size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/EmailsAgendado",

        name: "Emails Programados",

        icon: <MdEventAvailable size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      }

    ],

    kanban: [

      {

        path: "/kanban",

        name: "Painel Kanban",

        icon: <MdViewKanban size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/tagsKanban",

        name: "Tags Kanban",

        icon: <MdLabelOutline size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/campanhas",

        name: "Em Andamento",

        icon: <MdPlayCircleOutline size={18} />,

        condition: (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      }

    ],

    campaigns: [

      {

        path: "/campaigns",

        name: "Campanhas",

        icon: <TrendingUp size={22} strokeWidth={1.5} />,

        condition: showCampaigns

      },

      {

        path: "/contact-lists",

        name: "Listas de Contactos",

        icon: <Contact size={22} strokeWidth={1.5} />,

        condition: showCampaigns

      },

      {

        path: "/campaigns-config",

        name: "Configurações",

        icon: <Settings2 size={22} strokeWidth={1.5} />,

        condition: showCampaigns

      }

    ],

    evaluation: [

      {

        path: "/ratings",

        name: "Calificaciones",

        icon: <MdStar size={18} />

      },

      {

        path: "/assessmentReport",

        name: "Encuesta de Satisfacción",

        icon: <MdFeedback size={18} />

      }

    ],

    tools: [

      {

        path: "/queues",

        name: "Filas y Chatbot",

        icon: <MdQueue size={18} />

      },

      {

        path: "/flowbuilders",

        name: "Fluxo Bot",

        icon: <MdBuild size={18} />,

        condition: useShowFlowBuilder && plano === "ultimate"

      }

    ],

    admin: [

      {

        path: "/users",

        name: "Usuarios",

        icon: <MdPeople size={18} />

      },

      {

        path: "/messages-api",

        name: "API de Mensajes",

        icon: <MdSettings size={18} />,

        condition: showExternalApi

      },

      {

        path: "/connections",

        name: "Conexiones",

        icon: <MdSettings size={18} />

      },

      {

        path: "/financeiro",

        name: "Financiero",

        icon: <MdAccountBalance size={18} />,

        condition: (plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/settings",

        name: "Configuraciones",

        icon: <MdSettings size={18} />

      },

      {

        path: "/companies",

        name: "Empresas",

        icon: <MdBusiness size={18} />,

        condition: user.super && (plano === "basico" || plano === "empresarial" || plano === "ultimate")

      },

      {

        path: "/announcements",

        name: "Anuncios",

        icon: <MdLabel size={18} />,

        condition: user.super

      }

    ]

  };



  const renderMenuItem = (item) => {

    if (item.condition === false) return null;

    

    return (

      <ListItemLink

        key={item.path}

        to={item.path}

        primary={item.name}

        icon={React.cloneElement(item.icon, { className: classes.iconColor })}

        disabled={subscriptionExpired}

        className={`${classes.listItem} ${subscriptionExpired ? classes.disabledItem : ""}`}

        style={subscriptionExpired ? { pointerEvents: "none" } : {}}

        onClick={drawerClose}

      />

    );

  };



  const renderCategory = (title, items) => {

    const filteredItems = items.filter(item => item.condition !== false);

    if (filteredItems.length === 0) return null;



    return (

      <>

        <Typography

          variant="subtitle2"

          className={classes.categoryTitle}

        >

          {title}

        </Typography>

        {filteredItems.map(renderMenuItem)}

      </>

    );

  };



  return (

    <div>

      {renderCategory("Principal", menuCategories.main)}
      
      <Divider style={{ margin: "16px 0" }} />
      {renderCategory("Estados WhatsApp", menuCategories.whatsappStatus)}
      
      <Divider style={{ margin: "16px 0" }} />
      {renderCategory("Llamadas", menuCategories.calls)}
      
      {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (
        <>
          <Divider style={{ margin: "16px 0" }} />
          {renderCategory("Kanban", menuCategories.kanban)}

        </>

      )}

      

      {(plano === "basico" || plano === "empresarial" || plano === "ultimate") && (

        <>

          <Divider style={{ margin: "16px 0" }} />

          {renderCategory("Email", menuCategories.email)}

        </>

      )}

      

      {(user.super || user.profile === 'admin') && (

        <>

          {showCampaigns && (

            <>

              <Divider style={{ margin: "16px 0" }} />

              {renderCategory("Campanhas", menuCategories.campaigns)}

            </>

          )}

          <Divider style={{ margin: "16px 0" }} />

          {renderCategory("Calificación", menuCategories.evaluation)}

          <Divider style={{ margin: "16px 0" }} />

          {renderCategory("Ferramentas", menuCategories.tools)}

          <Can

            role={user.profile}

            perform="drawer-admin-items:view"

            yes={() => (

              <>

                <Divider style={{ margin: "16px 0" }} />

                {renderCategory("Administração", menuCategories.admin)}

              </>

            )}

          />

        </>

      )}



      <Divider style={{ margin: "16px 0" }} />

      <ListItem

        button

        dense

        onClick={handleClickLogout}

        className={classes.logoutButton}

      >

        <ListItemIcon>

          <RotateRight style={{ color: "#fff" }} />

        </ListItemIcon>

        <ListItemText primary="Salir" />

      </ListItem>



      {user.super && !collapsed && (

        <>

          <Divider />

          <Typography

            style={{

              fontSize: "12px",

              padding: "10px",

              textAlign: "right",

              fontWeight: "bold",

            }}

          >

            V: {version} - <span style={{ color: '#4CAF50' }}>PRO</span>

          </Typography>

        </>

      )}

    </div>

  );

};



export default MainListItems;



